import React, { useState, useEffect, useRef } from 'react';
/* eslint-disable */
import * as Yup from 'yup';
// material
import { Container, Card, Tooltip } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button, Box, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import services from '../Service';
import { Autocomplete } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import PropTypes from 'prop-types';
import SearchNotFound from '../../../SearchNotFound';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import { toDate } from 'date-fns';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';


const useStyles = makeStyles({
  table: {
    minWidth: 750
  }
});

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "COPREPORT"

export default function COPReport(props) {
  const classes = useStyles();
  const componentRef = useRef();
  const [date1, setDate1] = useState(new Date());
  const [date2, setDate2] = useState(new Date());
  const [groupFactory, setGroupFactory] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [farmer, setFarmer] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [open, setOpen] = React.useState(false);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [imageRotation, setImageRotation] = useState(0);
  const [copDetails, setCOPDetails] = useState([]);
  const [isTable, setIsTable] = useState(false);
  let encrypted = '';
  const navigate = useNavigate();
  const [isFarmerClear, setIsFarmerClear] = useState(false);
  const [selectedOptionsFCC, setSelectedOptionsFCC] = useState([]);
  const [selectedOptionsFarmer, setSelectedOptionsFarmer] = useState([]);
  const [formData, setFormData] = useState({
    groupID: '0',
    operationEntityID: '0',
    farmerID: '0'
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    startDate: '',
    endDate: '',
    routeName: ''
  });
  const handleClose = () => {
    setOpen(false);
  };

  const getCurrentDate = () => {
    const date = new Date();
    return date.toISOString().split('T')[0];
  };
  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: selectedOptionsFCC,
      farmerID: selectedOptionsFarmer,
      fromDate: date1.toISOString().split('T')[0],
      toDate: date2.toISOString().split('T')[0]
    },

    validationSchema: () => {
      return Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.array()
          .min(1, 'Please select at least one Fresh collection center')
          .required('Please select at least one Fresh collection center'),
        farmerID: Yup.array()
          .min(1, 'Please select at least one Farmer')
          .required('Please select at least one Farmer'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
      });
    },

    onSubmit: (values) => {
      trackPromise(SubmitForm());
    }
  }
  );
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImageRotation(0); 
    setImageViewerOpen(true);
  };

  const handleImageViewerClose = () => {
    setImageViewerOpen(false);
    setSelectedImage('');
  };

  const rotateImageLeft = () => {
    setImageRotation((prev) => (prev - 90) % 360);
  };

  const rotateImageRight = () => {
    setImageRotation((prev) => (prev + 90) % 360);
  };
  

  function getSelectedDropdownValuesForReport() {
    const facName = [];
    selectedOptionsFCC.forEach(x => {
      const fildered = operationEntityList.find(y => x === y.value).label
      facName.push(fildered)
    });
    var grpname
    {
      groupList.map((x) => (
        x.groupID == formik.values.groupID ? grpname = x.groupName : null
      ))
    }
    var operationentityname
    {
      operationEntityList.map((x) => (
        x.factoryID == formik.values.operationEntityID ? operationentityname = x.factoryName : null
      ))
    }
    var farmername
    {
      farmer.map((x) => (
        x.farmerID == formik.values.farmerID ? farmername = x.givenName : null
      ))
    }
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: grpname,
      operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
      routeName: farmername,
      startDate: formik.values.fromDate,
      endDate: formik.values.toDate,
    });
  }

  async function SubmitForm() {
    let model = {
      FarmerID: selectedOptionsFarmer.map(x => x).join(',').toString(),
      GroupID: parseInt(formik.values.groupID),
      OperationEntityID: selectedOptionsFCC.map(x => x).join(',').toString(),
      FromDate: formik.values.fromDate,
      ToDate: formik.values.toDate
    }
    var res = await services.GetDetailsForCOPReport(model);
    setCOPDetails(res)
    createDataForExcel(res);
    getSelectedDropdownValuesForReport();
  }

  async function createFile() {
    var file = await createDataForExcel(copDetails);
    var settings = {
      sheetName: 'Cost of Product Report',
      fileName: 'Cost of Product Report',
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: 'Cost of Product Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'Date': x.activityDate.split('T')[0],
          'FCC': x.factoryName,
          'Activity Name': x.activityName,
          'Plot/Crop': x.plotName,
          'Description': x.activityDescription,
          'Total Expenses(Rs)	': x.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
        res.push(vr);
      });

      res.push({});
      res.push({});

      // var vr1 = {
      //   'Activity Name': "Group: " + selectedSearchValues.groupName,
      //   'Date': "Fresh Collection Center: " + selectedSearchValues.operationEntityID,
      //   'Plot/Crop': "From: " + selectedSearchValues.startDate,
      //   'Description': "To: " + selectedSearchValues.endDate
      // }
      // res.push(vr1);
    }
    return res;
  }

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    GetAllGroups();
  }, [])

  useEffect(() => {
    GetOperationEntityByGroupID();
  }, [formik.values.groupID]);

  useEffect(() => {
    if (selectedOptionsFCC.length > 0) {
      trackPromise(GetFarmerDetailsByMultipleFactoryID());
    }
  }, [formik.values.operationEntityID, selectedOptionsFCC]);

  useEffect(() => {
    clear();
  }, [formik.values.operationEntityID]);

  useEffect(() => {
    setCOPDetails([]);
  }, [operationEntityList, formik.values.fromDate, formik.values.toDate]);

  useEffect(() => {
    setSelectedOptionsFCC(operationEntityList.map(option => option.value));
  }, [operationEntityList]);

  useEffect(() => {
    setValues({
      ...values,
      operationEntityID: selectedOptionsFCC,
      farmerID: selectedOptionsFarmer
    })
  }, [selectedOptionsFCC, selectedOptionsFarmer]);

  useEffect(() => {
    const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
    const selectedOptions = [factoryValue];
    setSelectedOptionsFCC(selectedOptions)
  }, [operationEntityList]);

  const handleSelectChange = (event) => {
    const selectedValues = event.target.value;
    if (selectedValues.includes('')) {
      setSelectedOptionsFCC(
        selectedOptionsFCC.length === operationEntityList.length ? [] : operationEntityList.map((option) => option.value)
      );
    } else {
      setSelectedOptionsFCC(selectedValues);
    }
    setCOPDetails([]);
  };

  const handleSelectChangeFarmer = (event) => {
    const selectedValues = event.target.value;
    if (selectedValues.includes('')) {
      setSelectedOptionsFarmer(
        selectedOptionsFarmer.length === farmer.length ? [] : farmer.map((option) => option.value)
      );
    } else {
      setSelectedOptionsFarmer(selectedValues);
    }
    setCOPDetails([]);
  };

  const handleClearSelection = () => {
    setSelectedOptionsFCC([]);
    setSelectedOptionsFarmer([]);
    setCOPDetails([]);
  };

  const handleClearSelectionFarmer = () => {
    setSelectedOptionsFarmer([]);
    setCOPDetails([]);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - copDetails.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCOPREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })

    setGroupFactory({
      ...groupFactory,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      var newOptionArray = [];
      for (var i = 0; i < res.length; i++) {
        newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
      }
      setOperationEntityList(newOptionArray);
    }
  }

  async function GetFarmerDetailsByMultipleFactoryID() {
    let model = {
      operationEntityID: selectedOptionsFCC.map(x => x).join(',').toString()
    }
    var res = await services.GetFarmerDetailsByMultipleFactoryID(model)
    if (res != null) {
      var newOptionArray2 = [];
      for (var i = 0; i < res.length; i++) {
        newOptionArray2.push({ label: res[i].givenName, value: res[i].farmerID })
      }
      setFarmer(newOptionArray2);
    }
  }

  function handleSearch(data, e) {

    if (data === undefined || data === null) {
      setValues({
        ...values,
        farmerID: '0'
      });
      return;
    } else {
      var valueV = data["farmerID"];

      setValues({
        ...values,
        farmerID: valueV.toString()
      });
    }
  }

  async function clearAll() {
    if (!permissionList.isFactoryFilterEnabled) {
      setSelectedOptionsFarmer([]);
      setCOPDetails([]);
      setDate1(new Date());
      setDate2(new Date());
      setValues({
        ...values,
        operationEntityID: selectedOptionsFCC,
        farmerID: selectedOptionsFarmer,
        fromDate: date1.toISOString().split('T')[0],
        toDate: date2.toISOString().split('T')[0]        
      })
    } else {
      setSelectedOptionsFCC([]);
      setSelectedOptionsFarmer([]);
      setCOPDetails([]);
      setDate1(new Date());
      setDate2(new Date());
      setValues({
        ...values,
        operationEntityID: selectedOptionsFCC,
        farmerID: selectedOptionsFarmer,
        fromDate: date1.toISOString().split('T')[0],
        toDate: date2.toISOString().split('T')[0]        
      })
    }
  }

  async function clear() {
    setCOPDetails([]);
  }

  async function setUpdateCrop(data) {
    var res = await services.GetExpenseDetailsbyFarmerActivityID(data)
    if (res != null) {
      setExpenseList(res);
    }
    setOpen(true);
  }

  const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  const renderSelectedValueFCC = (selected) => {
    if (selected.length === 0) {
      return 'Select Options';
    } else if (selected.length === 1) {
      const option = operationEntityList.find((entity) => entity.value === selected[0]);
      return option ? <Chip label={option.label} /> : '';
    } else {
      const selectedChips = selected.map((value, index) => {
        if (index === 0) {
          const option = operationEntityList.find((entity) => entity.value === value);
          return option ? <Chip label={option.label} /> : null;
        } else {
          const option = operationEntityList.find((entity) => entity.value === value);
          return option ? <Chip key={index} label={option.label} /> : null;
        }
      });
      const moreCount = selected.length - 1;
      return (
        <div>
          {selectedChips[0]} + {moreCount} more
        </div>
      );
    }
  };

  const renderSelectedValueFarmer = (selected) => {
    if (selected.length === 0) {
      return 'Select Options';
    } else if (selected.length === 1) {
      const option = farmer.find((entity) => entity.value === selected[0]);
      return option ? <Chip label={option.label} /> : '';
    } else {
      const selectedChips = selected.map((value, index) => {
        if (index === 0) {
          const option = farmer.find((entity) => entity.value === value);
          return option ? <Chip label={option.label} /> : null;
        } else {
          const option = farmer.find((entity) => entity.value === value);
          return option ? <Chip key={index} label={option.label} /> : null;
        }
      });
      const moreCount = selected.length - 1;
      return (
        <div>
          {selectedChips[0]} + {moreCount} more
        </div>
      );
    }
  };

  return (
    <>
      <LoadingComponent />
      <Page title="COP Report |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/createfirstForcast'}
            btname="Add"
            pageName="Cost of Product Report "
            leftButtonHidden={true}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>

                  <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                    <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                    <Select
                      labelId="multi-select-label"
                      id="multi-select"
                      multiple
                      size="small"
                      value={selectedOptionsFCC}
                      onChange={handleSelectChange}
                      label="Fresh Collection Center"
                      renderValue={(selected) => renderSelectedValueFCC(selected)}
                      disabled={!permissionList.isFactoryFilterEnabled}
                    >
                      <MenuItem key={0} value={""}>
                        <Checkbox checked={selectedOptionsFCC.length === operationEntityList.length} color="primary" />
                        All Fresh Collection Center
                      </MenuItem>
                      {operationEntityList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Checkbox checked={selectedOptionsFCC.indexOf(option.value) > -1} color="primary" />
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.operationEntityID && errors.operationEntityID && (
                      <FormHelperText>{errors.operationEntityID}</FormHelperText>
                    )}
                    {selectedOptionsFCC.length > 0 && (
                      <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                        {!permissionList.isFactoryFilterEnabled ? null :
                          <ClearIcon />}
                      </IconButton>
                    )}
                  </FormControl>

                  <FormControl fullWidth error={Boolean(touched.farmerID && errors.farmerID)}>
                    <InputLabel id="multi-select-label">Farmer *</InputLabel>
                    <Select
                      labelId="multi-select-label"
                      id="multi-select"
                      multiple
                      size="small"
                      value={selectedOptionsFarmer}
                      onChange={handleSelectChangeFarmer}
                      label="Farmer"
                      renderValue={(selected) => renderSelectedValueFarmer(selected)}
                    >
                      <MenuItem key={0} value={""}>
                        <Checkbox checked={selectedOptionsFarmer.length === farmer.length} color="primary" />
                        All Farmers
                      </MenuItem>
                      {farmer.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Checkbox checked={selectedOptionsFarmer.indexOf(option.value) > -1} color="primary" />
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.farmerID && errors.farmerID && (
                      <FormHelperText>{errors.farmerID}</FormHelperText>
                    )}
                    {selectedOptionsFarmer.length > 0 && (
                      <IconButton onClick={handleClearSelectionFarmer} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                        <ClearIcon />
                      </IconButton>
                    )}
                  </FormControl>

                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    fullWidth
                    size="small"
                    id="date"
                    label=" From Date *"
                    type="date"
                    value={formik.values.fromDate}
                    onChange={formik.handleChange}
                    {...getFieldProps('fromDate')}
                    error={Boolean(touched.fromDate && errors.fromDate)}
                    helperText={touched.fromDate && errors.fromDate}
                    inputProps={{max: getCurrentDate()}}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>
                    }}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    id="date"
                    label=" To Date *"
                    type="date"
                    value={formik.values.toDate}
                    onChange={formik.handleChange}
                    {...getFieldProps('toDate')}
                    error={Boolean(touched.toDate && errors.toDate)}
                    helperText={touched.toDate && errors.toDate}
                    inputProps={{max: getCurrentDate()}}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>
                    }}
                  />
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                      Clear
                    </Button>
                    <Button type="submit" color="secondary" variant="outlined">
                      Search
                    </Button>
                  </Stack>
                </Stack>

                {copDetails.length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">

                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Date</TableCell>
                              <TableCell align="center">FCC</TableCell>
                              <TableCell align="left">Activity Name</TableCell>
                              <TableCell align="center">Plot/Crop</TableCell>
                              <TableCell align="center">Description</TableCell>
                              <TableCell align="right">Total Expenses(Rs)</TableCell>
                              <TableCell align="center">Image </TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {(rowsPerPage > 0
                              ? copDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : copDetails).map((row) => (
                                <TableRow>
                                 
                                 <TableCell align="center">
                                    {new Date(row.activityDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                  </TableCell>
                                  <TableCell align="center">{row.factoryName}</TableCell>
                                  <TableCell align="left">{row.activityName}</TableCell>
                                  <TableCell align="center">{row.plotName}</TableCell>
                                  <TableCell align="center">{row.activityDescription}</TableCell>
                                  <TableCell align="right">{row.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                  <TableCell align="center">
                                         {row.imageLink ? (
                                            <img 
                                              src={row.imageLink} 
                                              alt="Activity" 
                                              style={{ width: '50px', height: '50px', objectFit: 'cover', cursor: 'pointer' }}
                                              onClick={() => handleImageClick(row.imageLink)}
                                            />
                                      ) : (
                                        <span>No image</span>
                                      )}
                                  </TableCell>

                                  <TableCell align="center">
                                    <Tooltip title="Expenses List">
                                      {row.value !== 0 ? (
                                        <IconButton aria-label="eye" onClick={() => trackPromise(setUpdateCrop(row.farmerActivityID))}>
                                          <VisibilityIcon />
                                        </IconButton>
                                      ) : (
                                        <IconButton aria-label="eye" disabled>
                                          <VisibilityIcon />
                                        </IconButton>
                                      )}
                                    </Tooltip>
                                  </TableCell>

                                </TableRow>
                              ))}

                            {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}

                          </TableBody>

                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={7}
                                count={copDetails.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    'aria-label': 'rows per page',
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>

                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack> : <SearchNotFound searchQuery="COP Details" />}
              </Stack>
            </Form>
          </FormikProvider>

          <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{"Expenses List"}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Container>
                  <Card style={{ justifycontent: 'center', width: '31rem' }}>
                    <Paper className={classes.root}>
                      <TableContainer component={Paper}>
                        <Table aria-label="collapsible table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="left" style={{ fontWeight: 'bold' }}>Name</TableCell>
                              <TableCell align="right" style={{ fontWeight: 'bold' }}>Cost(Rs)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {expenseList.map((row, i) => (
                              <TableRow key={i}>
                                <TableCell component="th" scope="row" align="left"> {row.expenseName}</TableCell>
                                <TableCell component="th" scope="row" align="right"> {row.value}</TableCell>
                              </TableRow>
                            )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Card>
                  <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                      CANCEL
                    </Button>
                  </DialogActions>
                </Container>
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <br />
          {copDetails.length > 0 ?
            <Box display="flex" justifyContent="flex-end" p={2}>
              <Button
                color="primary"
                id="btnRecord"
                type="submit"
                variant="contained"
                style={{ marginRight: '1rem' }}
                className={classes.colorRecord}
                onClick={() => createFile()}
              >
                EXCEL
              </Button>
              <ReactToPrint
                documentTitle={"COP Report"}
                trigger={() => <Button
                  color="primary"
                  id="btnRecord"
                  type="submit"
                  variant="contained"
                  style={{ marginRight: '1rem', backgroundColor: 'red' }}
                  className={classes.colorCancel}
                  onClick={() => getSelectedDropdownValuesForReport()}
                >
                  PDF
                </Button>}
                content={() => componentRef.current}
              />
              <div hidden={true}>
                <CreatePDF ref={componentRef}
                  advancedPaymentList={copDetails} searchData={selectedSearchValues}
                />
              </div>
            </Box> : null}
            <Dialog 
            open={imageViewerOpen} 
            onClose={handleImageViewerClose}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <span></span>
                <Box>
                  <IconButton onClick={rotateImageLeft} color="primary">
                    <RotateLeftIcon />
                  </IconButton>
                  <IconButton onClick={rotateImageRight} color="primary">
                    <RotateRightIcon />
                  </IconButton>
                  <IconButton onClick={handleImageViewerClose}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="400px"
              >
                <img 
                  src={selectedImage} 
                  alt="Activity" 
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '70vh',
                    transform:` rotate(${imageRotation}deg)`,
                    transition: 'transform 0.3s ease'
                  }} 
                />
              </Box>
            </DialogContent>
          </Dialog>
        </Container>
      </Page>
    </>
  );
}